import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { DataMainTemplate } from "@nocios/presentation-kit";
import Config from "src/Constants/Config";
import setCurrentPage from "src/Utils/setCurrentPage";
import AnimtionLeftPanelBlue from "src/Component/AnimtionLeftPanelBlue";
import ChatMessageAnimation from "../../Component/ChatMessageAnimation";

// Constants
const PAGE_ID = 7;
const BG_ID = 5;
const BG_TYPE = "jpg";
const NEXT_PAGE_ID = PAGE_ID + 1;
const BACK_PAGE_ID = PAGE_ID - 1;

const LEFT_TITLE = "Elevated Customer Experience";

// Main data function that returns the template data
const DATA = (): DataMainTemplate => {
  const currentPage = useSelector((state: { appReducer: { currentPage: number } }) => state.appReducer.currentPage);
  const [step, setStep] = useState(0);
  const baseImageBG = `${Config.BASE_URL}/images/BG/`;

  const backButton =
    BACK_PAGE_ID > 0
      ? {
          label: "Back",
          type: "back" as const,
          startIcon: { icon: "arrow-right", color: "#fff" },
          onClick: () => setCurrentPage(BACK_PAGE_ID),
          style: {
            borderRadius: "45px",
            padding: "var(--width-5) var(--width-25)",
            gap: "var(--width-16)",
          },
        }
      : undefined;

  const nextButton = {
    label: "Next",
    type: "next" as const,
    endIcon: { icon: "arrow-left" },
    onClick: () => setCurrentPage(NEXT_PAGE_ID),
    style: {
      borderRadius: "45px",
      padding: "var(--width-5) var(--width-25)",
      gap: "var(--width-16)",
    },
  };

  const [startAnimation, setStartAnimation] = useState(false);

  useEffect(() => {
    if (currentPage === PAGE_ID) {
      setTimeout(() => {
        setStep(1);
        setTimeout(() => {
          setStartAnimation(true);
        }, 500);
      }, 400);
    } else {
      setStep(0);
      setStartAnimation(false);
    }
  }, [currentPage]);

  return {
    styleBody: {
      marginTop: "var(--height-40)",
    },
    styleTitle: {
      color: "#fff",
      fontFamily: "Tungsten",
      fontSize: "var(--width-64)",
      fontStyle: "normal",
      fontWeight: "500",
      lineHeight: "110%",
      textTransform: "uppercase",
      paddingBottom: "var(--width-10)",
    },
    bgImage: `${baseImageBG}BG_${BG_ID}.${BG_TYPE}`,
    title: LEFT_TITLE,
    description:
      '<ul id="ilo-ul-screen-4"><li>Customer delight with proactive communication</li><li>On time service activation</li><li>Reduction in Order Fall Out Management</li><li>E2E order visibility</li><li>Reduction in manual reconciliation effort</li></ul>',
    leftAfterDescription: (
      <>
        <AnimtionLeftPanelBlue
          style={{
            left: "calc(-1 * var(--width-102))",
            width: "var(--width-792)",
            top: "var(--height-320)",
          }}
          startAnimation={startAnimation}
          image={`${Config.BASE_URL}/images/screen_${PAGE_ID}/left_0.png`}
        />
        <img style={{ width: "var(--width-586)" }} src={`${Config.BASE_URL}/images/screen_7/personas.png`} alt="" />
      </>
    ),
    rightSideComponent: (
      <>
        <img
          style={{
            transition: "all 0.4s ease",
            opacity: step === 1 ? 1 : 0,
            position: "relative",
            zIndex: 10,
            height: "var(--height-259)",
          }}
          src={`${Config.BASE_URL}/images/screen_${PAGE_ID}/right_initial.png`}
          alt=""
        />
        <ChatMessageAnimation
          startAnimation={startAnimation}
          baseImagePath={`${Config.BASE_URL}/images/screen_${PAGE_ID}/right_`}
          containerStyle={{
            position: "absolute",
            top: 0,
            right: 0,
            width: "100%",
            height: "100%",
            overflow: "hidden",
          }}
          chatWidth="var(--width-700)" // Width of the chat container
          verticalSpacing="1%" // Less space between messages
          maxWidth="var(--width-800)" // Maximum width of each message
          scaleArray={[1, 1, 1, 1, 1]}
          transformPositionX="20%"
          transformPositionY="-15%"
          // New properties for scroll functionality
          enableScroll={true} // Enable the scroll functionality
          scrollThreshold={4} // Start scrolling after 3 messages
        />
      </>
    ),
    next: nextButton,
    back: backButton,
  };
};

export default DATA;
